// extracted by mini-css-extract-plugin
module.exports = {"bold-value":"course-fees-and-pricing_bold-value__DggBj","fee-row":"course-fees-and-pricing_fee-row__wQyzq"};